import { configureStore } from '@reduxjs/toolkit';
import * as AppConstants from './AppConstants';
import * as AppUtilities from "../context/AppUtilities";
import { v4 as uuidv4 } from 'uuid';

let store = null;

// Try not to use this global state too much
const simpleGlobalState = {};
simpleGlobalState[AppConstants.SIMPLE_GLOBAL_STATE.DEFAULT_SHOW_DEBUG] = AppConstants.IS_DEVELOPMENT;

function updateState(action, payload) {
  store.dispatch(createDispatch(action, payload));
}

function createDispatch(action, payload) {
  return {
    type: action,
    payload: payload,
  };
}

function createStore(savedState) {
  if (!savedState) {
    savedState = {};
  }
  const defaultState = Object.assign({}, AppConstants.DEFAULT_STATE, savedState);

  if (AppUtilities.DEBUGLEVEL.state) {
    AppUtilities.debug("createStore initial state:");
    AppUtilities.dir(defaultState);
  }

  store = configureStore({
    reducer: (state = defaultState, action) => {
      switch (action.type) {
        case AppConstants.DISPATCH.RESET_STATE:
          return defaultState;
        case AppConstants.DISPATCH.SET_INITIAL_DATA:
          return {
            ...state,
            locations: action.payload.locations,
            locations_online: action.payload.locations_online,
            ads: action.payload.ads,
          };
        case AppConstants.DISPATCH.LIGHT_MODE:
          return {
            ...state,
            lightMode: action.payload,
          };
        case AppConstants.DISPATCH.EXTRA_DEBUG:
          if (action.payload) {
            AppUtilities.setExtraDebug(true);
          }
          return {
            ...state,
            extraDebug: action.payload,
          };
        case AppConstants.DISPATCH.SET_LAST_MAIN_VIEW:
          return {
            ...state,
            lastMainView: action.payload,
          };
        case AppConstants.DISPATCH.SET_DELIVERY_LOCATION_FILTER:
          return {
            ...state,
            deliveryLocationFilter: action.payload,
          };
        case AppConstants.DISPATCH.SET_MAP_CENTER:
          return {
            ...state,
            mapCenter: action.payload,
          };
        case AppConstants.DISPATCH.MOVE_MAP:
          return {
            ...state,
            moveMap: action.payload,
          };
        case AppConstants.DISPATCH.UPDATE_DATA_FILTER:
          action.payload[AppConstants.SYNTHESIZED_TYPES.QUERY_ID[AppConstants.TYPE_KEYS.URL_KEY]] = uuidv4();
          return {
            ...state,
            dataFilter: action.payload,
            shouldAskToMoveToCurrentLocation: false,
          };
        case AppConstants.DISPATCH.UPDATE_LAST_GPS_LOCATION:
          return {
            ...state,
            lastGPSLocation: action.payload,
          };
        default:
          return state;
      }
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }),
  });
  return store;
}

function setGlobalState(key, value) {
  simpleGlobalState[key] = value;
}

function getGlobalState(key) {
  return simpleGlobalState[key];
}

function getAndSetGlobalState(key, value) {
  const result = getGlobalState(key);
  setGlobalState(key, value);
  return result;
}

function getAllGlobalState() {
  return simpleGlobalState;
}

async function checkAndHandleInitialLoad(showTemporarySnack, learnMore) {
  if (AppUtilities.isWeb()) {
    const usedAppBefore = AppUtilities.getLocalData(AppConstants.LOCAL_DATA_KEYS.USED_APP_BEFORE, false);
    if (!usedAppBefore) {
      await AppUtilities.updateLocalData(AppConstants.LOCAL_DATA_KEYS.USED_APP_BEFORE, true);
      /*showTemporarySnack(
        "Welcome to Find Humane which helps find humanely raised animal products.\n\nUse the Map to find local products or the Delivery tab for frozen delivery services.",
        null, //"Learn More",
        null, //learnMore,
        30000,
      );*/
    }
  }
}

async function shouldPopUpSubscribe() {
  const seenSubscribePopup = AppUtilities.getLocalData(AppConstants.LOCAL_DATA_KEYS.SEEN_SUBSCRIBE_POPUP, false);
  if (seenSubscribePopup) {
    return false;
  } else {
    await AppUtilities.updateLocalData(AppConstants.LOCAL_DATA_KEYS.SEEN_SUBSCRIBE_POPUP, true);
    return true;
  }
}

function changeCertificationGroup(currentFilter, newGroup, dispatcher) {
  AppUtilities.info("AppState.changeCertificationGroup newGroup: " + newGroup);
  let newFilter = Object.assign({}, currentFilter);
  newFilter = AppConstants.clearBuiltinOptions(Object.assign({}, newFilter));
  newFilter[newGroup] = "y";

  // Save off permanently
  let stateToUpdate = AppUtilities.getSavedAppState(
    "dataFilter",
    AppConstants.getDefaultDataFilter(),
  );

  AppUtilities.info("AppState.changeCertificationGroup: previous saved dataFilter or default:");
  AppUtilities.dir(stateToUpdate);

  stateToUpdate = Object.assign(
    {},
    AppConstants.clearBuiltinOptions(Object.assign({}, stateToUpdate)),
    {
      [newGroup]: "y",
    },
  );

  AppUtilities.info("AppState.changeCertificationGroup: new saved state:");
  AppUtilities.dir(stateToUpdate);

  AppUtilities.updateSavedAppState(
    "dataFilter",
    stateToUpdate,
  );

  dispatcher(createDispatch(AppConstants.DISPATCH.UPDATE_DATA_FILTER, newFilter));
}

export {
  createStore,
  updateState,
  createDispatch,
  setGlobalState,
  getGlobalState,
  getAndSetGlobalState,
  checkAndHandleInitialLoad,
  getAllGlobalState,
  shouldPopUpSubscribe,
  changeCertificationGroup,
}
